import Image from "next/image";
import React from "react";

const clients = [
  {
    text: "AVAAZ",
    image: "/images/SVG/partners/avaaz.svg",
  },
  {
    text: "Refuser Support Network",
    image: "/images/JPG/partners/rsn.jpg",
  },
  {
    text: "University of Michigan",
    image: "/images/SVG/partners/michigan.svg",
  },
];

export default function ClientsList() {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      {clients.map((client) => (
        <article
          key={client.text}
          className="flex h-full flex-col gap-4 rounded-lg  md:p-5 p-23 shadow-sm"
        >
          <div className="flex h-full items-center justify-center rounded-lg border border-foreground/10 bg-white p-4 relative">
            {client.text === "AVAAZ" && (
              <div className="absolute left-0 bottom-2 text-xs p-1 text-center text-secondary">
                — the global activist network with over 70 million members.
              </div>
            )}
            <Image
              src={client.image}
              width={112}
              height={72}
              alt=""
              unoptimized={client.image.endsWith(".svg")}
              className="h-full w-full object-contain"
            />
          </div>
          <p className="font-Cabin text-base font-semibold leading-relaxed text-foreground/85 dark:text-foreground/90 md:text-left text-center">
            {client.text}
          </p>
        </article>
      ))}
    </div>
  );
}
